

import {Navbar,Footer, AcrEntry} from '../acrcomponents'

function Home() {

  if(localStorage.getItem('regEmail')===null){
    window.location.replace('/acrlogin');
  }

  return (
    <>
    <div className='container'>
      <Navbar />
      <AcrEntry/>
      <Footer/>
    </div>


    </>
  )
}

export default Home